import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { GeneticMaterialTypeService } from '../proxy/general/controllers/genetic-material-type.service';
import { GeneticMaterialOriginService } from '../proxy/general/controllers/genetic-material-origin.service';
import { SpeciesService } from '../proxy/general/controllers/species.service';
import { GeneticMaterialGroupService } from '../proxy/general/controllers/genetic-material-group.service';
import { GeneticMaterialCrossingService } from '../proxy/general/controllers/genetic-material-crossing.service';
import { SanitaryClassificationService } from '@planning/proxy/planning/controllers';

FieldBuilder.setNamespace('General');

export const GENETICMATERIAL_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.GeneticMaterial.Name')
    .required()
    .minLength(1)
    .maxLength(200)
    .build(),
  FieldBuilder
    .foreignKey('geneticMaterialCrossingId', 'Entity.GeneticMaterialCrossing', GeneticMaterialCrossingService)
    .displayFromNested('geneticMaterialCrossing.name')
    .sortBy('geneticMaterialCrossing.name')
    .build(),
  FieldBuilder
    .text('notes', 'Entity.GeneticMaterial.Notes')
    .minLength(1)
    .maxLength(200)
    .build(),
  FieldBuilder
    .checkbox('isCommercialMaterial', 'Entity.GeneticMaterial.IsCommercialMaterial')
    .build(),
  FieldBuilder
    .checkbox('isThirdParty', 'Entity.GeneticMaterial.IsThirdParty')
    .build(),
  FieldBuilder
    .text('remsoftName', 'Entity.GeneticMaterial.RemsoftName')
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
      .foreignKey('sanitaryClassificationId', 'Entity.GeneticMaterial.SanitaryClassification', SanitaryClassificationService)
      .display('name')
      .keyField('id')
      .build(),
  FieldBuilder
    .foreignKey('geneticMaterialTypeId', 'Entity.GeneticMaterialType', GeneticMaterialTypeService)
    .required()
    .displayFromNested('geneticMaterialType.name')
    .sortBy('geneticMaterialType.name')
    .build(),
  FieldBuilder
    .foreignKey('geneticMaterialOriginId', 'Entity.GeneticMaterialOrigin', GeneticMaterialOriginService)
    .required()
    .displayFromNested('geneticMaterialOrigin.name')
    .sortBy('geneticMaterialOrigin.name')
    .build(),
  FieldBuilder
    .foreignKey('speciesId', 'Entity.Species', SpeciesService)
    .required()
    .displayFromNested('species.name')
    .sortBy('species.name')
    .build(),
  FieldBuilder
    .foreignKey('geneticMaterialGroupId', 'Entity.GeneticMaterialGroup', GeneticMaterialGroupService)
    .displayFromNested('geneticMaterialGroup.name')
    .sortBy('geneticMaterialGroup.name')
    .build(),
];

export const GENETICMATERIAL_CONFIG = {
  entityName: 'GeneticMaterial',
  localizationKey: 'General::Entity.GeneticMaterial',
  fields: GENETICMATERIAL_FIELDS,
  permission: 'ResearchAndDevelopmentGeneticMaterial.GeneticMaterials',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.ResearchAndDevelopment + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.GeneticMaterial + MENU_NAME_SUFFIX,
};
